import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  async copy() {
    await import('copy-text-to-clipboard').then((module) =>
      module.default(this.element.dataset.copyToClipboard),
    );

    this.element.classList.add('o-button--copied');

    setTimeout(() => {
      this.element.classList.remove('o-button--copied');
    }, 1000);
  }
}
